module.exports = __webpack_public_path__ + "img/LTS_KPMG_TEST.9ea0c705.gif";